import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { ClassTableFrame } from '@features/class/components/ClassTableFrame'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/_teacher-portal/groups/classes/$classId/')({
    component: RouteComponent,
})

function RouteComponent() {
    return (
        <QueryErrorBoundary title="Failed to load class" description="We couldn't load the class. Please try again, and if the problem persists, contact support.">
            <Suspense fallback={<LoadingIndicator resource='class' />}>
                <ClassTableFrame columnGroup='list'/>
            </Suspense>
        </QueryErrorBoundary>
    )
}